<template>
  <div class="games-row">
      <div class="games">
        <slot v-for="(item, name) in _.sortBy(games, ['sort'])" v-if="(isMobile && _.includes(item.devices, 'mobile')) || (!isMobile && _.includes(item.devices, 'desktop'))">
          <slot v-if="currentCategory == 'all' || ((currentProvider == item.provider || currentProvider == 'all'))">
            <Game class="game-item" :style="infiniteGames(name)" :class="[{ 'game_is_new' : item.is_new == '1',  }, 'game_' + item.id]" :key="item.id + '_' + name">
              <template slot="title">
                <span v-if="isMobile"  @click="runGame({id: item.id, device: isMobile, title: item.title})">{{ item.title }} <div class="provider">{{ item.provider }}</div></span>
                <span v-else>{{ item.title }} <div class="provider">{{ item.provider.replace('egtd', 'EGT Digital') }}</div></span>
              </template>
              <template slot="is_new">
                <div class="is_new" v-if="item.is_new == '1'">
                  YENİ!
                </div>
                <slot v-if="item.provider == 'pragmaticplay'">
                  <div class="is_dropwins" v-if="item.is_promotion == '1'">
                    <img :src="cdn_url + 'providers/dropwins.png'" alt="">
                  </div>
                </slot>
                <slot v-if="item.provider == 'egtd'">
                  <div class="is_dropwins" v-if="item.is_promotion == '1'" style=" top: 5px; left: 5px; ">
                    <img :src="cdn_url + '/providers/egt/clover-2.png'" style="width: 40px !important; height: 35px !important; border-radius: 0px !important;">
                  </div>
                </slot>
                <slot v-if="item.provider == 'egtd'">
                  <div class="is_dropwins" v-if="item.has_jackpot == '1'" style=" top: 0px; left: 5px; ">
                    <img :src="cdn_url + '/providers/egt/prog-1.png'" style="width: 50px !important; height: 25px !important; border-radius: 0px !important;">
                  </div>
                </slot>
                <slot v-if="item.provider == 'egtd'">
                  <div class="is_dropwins" v-if="item.is_promotion_2 == '1'" style=" top: 5px; left: 5px; ">
                    <img :src="cdn_url + '/providers/egt/bell-1.png'" style="width: 40px !important; height: 35px !important; border-radius: 0px !important;">
                  </div>
                </slot>
                <slot v-if="item.provider == 'egtd'">
                  <div class="is_dropwins" v-if="item.is_promotion_3 == '1'" style=" top: 5px; left: 5px; ">
                    <img :src="cdn_url + '/providers/egt/high-1.png'" style="width: 40px !important; height: 40px !important; border-radius: 0px !important;">
                  </div>
                </slot>
                <slot v-if="item.provider == 'egtd'">
                  <div class="is_dropwins" v-if="item.is_promotion_4 == '1'" style=" top: 5px; left: 5px; ">
                    <img :src="cdn_url + '/providers/egt/vip-bell-link.png'" style="width: 40px !important; height: 40px !important; border-radius: 0px !important;">
                  </div>
                </slot>
            
            
              </template>
              <template slot="img">
                  <v-lazy-image v-if="isMobile" @click="runGame({id: item.id, device: isMobile})" :src="item.image_full_path.replace('{domain}', current_domain).replace('https://static.egamings.com/games/', cdn_url + 'providers/')"/>
                  <v-lazy-image v-else :src="item.image_full_path.replace('{domain}', current_domain).replace('https://static.egamings.com/games/', cdn_url + 'providers/')"/>
              </template>
              <template slot="play">
                <div class="buttons">
                  <a href="javascript:;" @click="runGameFree({id: item.id, device: isMobile})" class="button secondary">
                    <svg viewBox="0 0 24 24" fill="none"> <path d="M21.4086 9.35258C23.5305 10.5065 23.5305 13.4935 21.4086 14.6474L8.59662 21.6145C6.53435 22.736 4 21.2763 4 18.9671L4 5.0329C4 2.72368 6.53435 1.26402 8.59661 2.38548L21.4086 9.35258Z"/> </svg>
                    Ücretsiz Oyna</a>
                  <a href="javascript:;" @click="runGame({id: item.id, device: isMobile, title: item.title})" class="button primary">
                    <svg viewBox="0 0 24 24" fill="none"> <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"/> <path d="M17 3.5H7C4 3.5 2 5 2 8.5V9V15V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V15V9V8.5C22 5 20 3.5 17 3.5ZM7 19C7 16.18 6.09 15.14 3.5 15.02V15V9V8.98C6.09 8.86 7 7.82 7 5H17C17 7.82 17.91 8.86 20.5 8.98V9V15V15.02C17.91 15.14 17 16.18 17 19H7Z"/> </svg>
                    Şimdi Oyna</a>
                </div>
              </template>
              <template slot="fav">
                  <a href="javascript:;" @click="$store.dispatch('slot/favorite', item)" class="fav" :class="{ active : _.indexOf(favorites, item.id) > -1}">
                      <svg viewBox="0 -10 511.99143 511" width="511pt"><path d="m510.652344 185.882812c-3.371094-10.367187-12.566406-17.707031-23.402344-18.6875l-147.796875-13.417968-58.410156-136.75c-4.3125-10.046875-14.125-16.53125-25.046875-16.53125s-20.738282 6.484375-25.023438 16.53125l-58.410156 136.75-147.820312 13.417968c-10.835938 1-20.011719 8.339844-23.402344 18.6875-3.371094 10.367188-.257813 21.738282 7.9375 28.925782l111.722656 97.964844-32.941406 145.085937c-2.410156 10.667969 1.730468 21.699219 10.582031 28.097656 4.757813 3.457031 10.347656 5.183594 15.957031 5.183594 4.820313 0 9.644532-1.28125 13.953125-3.859375l127.445313-76.203125 127.421875 76.203125c9.347656 5.585938 21.101562 5.074219 29.933593-1.324219 8.851563-6.398437 12.992188-17.429687 10.582032-28.097656l-32.941406-145.085937 111.722656-97.964844c8.191406-7.1875 11.308594-18.535156 7.9375-28.925782zm-252.203125 223.722657"/></svg>
                  </a>
              </template>
            </Game>
          </slot>
        </slot>
      </div>
        <infinite-loading force-use-infinite-wrapper="true" @infinite="infiniteHandler"  :identifier="identifier" ref="infiniteLoading">
          <span slot="no-more"></span>
          <span slot="spinner">
            <div class="spinner-dots"> <div class="spinner-dots--dot"></div> <div class="spinner-dots--dot"></div> <div class="spinner-dots--dot"></div> </div>
          </span>
        </infinite-loading>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import { mapActions } from 'vuex'
  import Game from './Game'
  import VLazyImage from "v-lazy-image/v2";
  import InfiniteLoading from 'vue-infinite-loading';
  export default{
    data(){
      return{
          limit : 34,
          identifier: +new Date(),
      }
    },
    components:{
      Game,
      VLazyImage,
      InfiniteLoading,
    },
    created(){
    },
    computed:{
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      searchValue(){
        return this.$store.getters['slot/getSearch'];
      },
      favorites(){
        return this.$store.getters['slot/getFavorites'];
      },
      games(){
        if(this.searchValue){
            let games =  this.$store.getters['slot/getGames'].filter(item => item.title.toLowerCase().includes(this.searchValue.toLowerCase()))
            return games
        }
        else{
          if(this.currentProvider == 'all'){

            let games = this.$store.getters['slot/getGames'];
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])

          }else if(this.currentCategory == 'fav'){
            let games = []
            this.favorites.forEach((value, index) => {
                let game = _.filter(this.$store.getters['slot/getGames'], ['id', value])[0];
                games.push(game);
            });
            return games;
          }else if(this.currentCategory == 'jackpot'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'has_jackpot': '1'})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else if(this.currentCategory == 'dropwins'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'is_promotion': '1'})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else if(this.currentCategory == 'bonanza'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'is_promotion_4': '1'})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else if(this.currentCategory == 'bell'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'is_promotion_2': '1'})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else if(this.currentCategory == 'vip_bell'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'is_promotion_4': '1'})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else if(this.currentCategory == 'high'){
            let games = _.filter(this.$store.getters['slot/getGames'], {'provider': this.currentProvider, 'is_promotion_3': '1'})
            
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else
          {

            let games = _.filter(this.$store.getters['slot/getGames'], ['provider', this.currentProvider])
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
            
          }
        }
      },
      currentCategory(){
        return this.$store.getters['slot/getCurrentCategory'];
      },
      currentProvider(){
        return this.$store.getters['slot/getCurrentProvider'];
      },
    },
    
    watch:{
      currentProvider(val){
          if(val == 'all'){
              this.limit = 2;
          }else{
              this.limit = 34;
          }
          this.identifier += 1;
      },
    },
    methods:{
      infiniteGames(key){
          if(_.isNull(this.searchValue) || _.isEmpty(this.searchValue)){
              if(key < this.limit){
                  return ''
              }else{
                  return 'display:none'
              }
          }
      },
      infiniteHandler($state){
          let hides = document.querySelectorAll('.games .game-item[style="display: none;"]');

          setTimeout(() => {
              if(this.currentProvider == 'all'){
                  this.limit = this.limit + 2;
              }else{
                  this.limit = this.limit + 34;
              }
              $state.loaded();

              if(hides.length === 0){
                  $state.complete();
              }
          }, 300);


      },
      runGameFree(payload){
          this.$store.dispatch('slot/runGameFree', payload)
      },
      runGame(payload){
        if(!this.$auth()){
          this.$emit('loginModal', true);
          return false;
        }else{
          this.$store.dispatch('slot/runGame', payload)
        }
      }
    },
  }
</script>

<style lang="scss">
  .infinite-spinner .app-loader{
    top:0px !important;
    margin:20px 0;
  }
  .is_dropwins{
    position: absolute;  height: 60px; 
    img{
      border-radius: 0px !important;
      height: 100% !important;
      border-top-left-radius: 20px !important;
    }
  }
  .item.game_is_new{
    order: 1 !important;
  }
  #app.slot .client-app .games .item{
    order: 9999;
  }
  #app.slot .client-app .games .item.game_is_new {
      display: block !important;
  }
  .is_new{
    position: absolute; 
    background: #ff0000; 
    background: linear-gradient(221deg, rgb(84 3 3) 0%, rgb(255 0 0) 100%);
    padding: 3px 10px; 
    border-radius: 10px; 
    font-size: 12px; 
    top: 0px; 
    right: -5px; 
    border: 0px solid; 
    z-index: 5; 
    box-shadow: 0px 0px 10px black; 
    text-transform: uppercase; 
    font-weight: bold;
  }
</style>